import threeLoginList from "../../layout-login/data/threeLoginList";
import tabList from '../data/tabs';
import {getUrlKey} from "@/util/util";


export default {
    data() {
        return {
            userinfo: {},
            isLogin: false,
            showMask: false,
            tabList,
            threeLoginList,
            v_selected: 0,
            keyword: '',              // 关键字
            is_login: false,
            is_reg: false,
            is_forget: false
        }
    },

    watch: {
        '$route'(to, from) {
            console.log(to);
            if(to.name !== 'news-detail' && to.name != 'star-detail') {
                
				document.title = '文娱中国——文娱中国APP官方网站'
            }
            if(to.name === 'index' || to.name === 'news-detail') {
                this.v_selected = 0;
            }else if(to.name === 'star' || to.name === 'star-detail') {
                this.v_selected = 1;
            }else if(to.name === 'active' || to.name === 'active-detail') {
                this.v_selected = 2;
            }else if(to.name === 'topic' || to.name === 'topic-detail') {
                this.v_selected = 3;
            }else if(to.name === 'download') {
                this.v_selected = 4;
            }else {
                this.v_selected = -1;
            }
        }
    },

    created() {
        this.v_selected = this.selected;
        this.isLogin = this.$isLogin();
        if(this.isLogin) {
            this.userinfo = this.$getUserinfo();
        }
    },

    methods: {
        checkLogin() {
            this.isLogin = this.$isLogin();
        },

        getUser() {
            this.userinfo = this.$getUserinfo();
        },

        // 打开完善资料页面
        openUserInfo() {
            this.$router.push({
                name: 'userinfo'
            })
        },

        // 退出登录
        outLogin() {

            this.$MessageBox.confirm('您确定要退出登录吗？',{
                type: 'warning'
            }).then(res => {
                localStorage.clear();
                this.isLogin = false;
                this.$store.commit('clearUser');
                let code = getUrlKey('code',location.href);
                if (code && code !== undefined) {
                    let url = location.href.split('?');
                    location.href = url[0];
                }else {
                    if(this.$route.name !== 'index') {
                        this.$router.replace({
                            name: 'index',
                            query: {}
                        })
                    }
                }
            })

        },

        // 切换tab
        changeTab(item,index) {
            this.v_selected = index;
            document.querySelector('.index').scrollTop = 0;
            this.$router.push({
                name: item.name
            })
        },

        onSearch() {
            if(!this.keyword.trim()){
                this.$message({
                    message: '请输入搜索关键字！',
                    type: "error"
                })
                return;
            };
            if(this.$route.name === 'search') {
                this.$router.replace({
                    name: 'search',
                    query: {
                        keyword: this.keyword
                    }
                })
                // this.$emit('search',this.keyword);
            }else {
                this.$router.push({
                    name: 'search',
                    query: {
                        keyword: this.keyword
                    }
                })
            }
        },

        openIndex() {
            this.$router.push({
                name: 'index'
            })
        },

        // 关闭弹窗
        closeMask() {
            this.showMask = false;
            this.is_login = false;
            this.is_reg = false;
            this.is_forget = false;
        },

        // 打开登录弹窗
        openLoginPop() {
            this.showMask = true;
            this.is_login = true;
            this.is_reg = false;
            this.is_forget = false;
        },

        // 打开注册弹窗
        openRegPop() {
            this.showMask = true;
            this.is_reg = true;
            this.is_login = false;
            this.is_forget = false;
        },

        // 打开忘记密码弹窗
        openForgetPop() {
            this.showMask = true;
            this.is_reg = false;
            this.is_login = false;
            this.is_forget = true;
        }
    }
}
